import { Component } from '@angular/core';

import type { ICellRendererParams } from '@ag-grid-community/core';
import type { ICellRendererAngularComp } from '@ag-grid-community/angular';

import { ILanguageCode } from 'rev-shared/media/transcription/TranscriptionLanguages.Service';

export interface ITranscriptSelectionCellRendererParams {
	getTranscriptionLanguages: () => ILanguageCode[];
}

interface ITranscriptSelectionCellRendererMergedParams extends ICellRendererParams, ITranscriptSelectionCellRendererParams { }

@Component({
	selector: 'transcript-selection-cell-renderer',
	template: `
		@if (!this.hasVtt) {
			<span>{{ 'None' | translate}}</span>
		} @else {
			<select
				class="form-select height-full"
				[(ngModel)]="selectedLanguageCode"
				[disabled]="!rowData.isSelected"
				(ngModelChange)="onLanguageChange()"
				(click)="stopPropagation($event)"
			>
				<option [ngValue]="null">{{ 'SelectLanguage' | translate }}</option>
				@for (language of transcriptionLanguages; track language) {
					<option [ngValue]="language.code">{{ language.name }}</option>
				}
			</select>
		}
	`,
	standalone: false
})
export class TranscriptSelectionCellRendererComponent implements ICellRendererAngularComp {
	public transcriptionLanguages: ILanguageCode[];
	public rowData: any;
	public hasVtt: boolean;
	public selectedLanguageCode: string;

	public agInit(params: ITranscriptSelectionCellRendererMergedParams): void {
		this.updateCell(params);
	}

	public refresh(params: ITranscriptSelectionCellRendererMergedParams): boolean {
		this.updateCell(params);
		return true; // nothing to do on refresh, so signal success
	}

	private updateCell(params: ITranscriptSelectionCellRendererMergedParams): void {
		this.hasVtt = params.value;
		this.rowData = params.data;
		this.transcriptionLanguages = params.getTranscriptionLanguages();
		this.selectedLanguageCode = this.rowData.vttLanguageCode;
	}

	public onLanguageChange(): void {
		this.rowData.vttLanguageCode = this.selectedLanguageCode;
	}

	public stopPropagation(event: Event): void {
		event.stopPropagation();
	}
}
